import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface DownloadDocumentProps {
  importerId: string;
  fileName: string;
}

export const useDownloadDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ importerId, fileName }: DownloadDocumentProps) => {
      const { data, headers } = await request(
        {
          path: `importer/download-document/${importerId}/${fileName}`,
          method: 'GET',
          authenticate: true,
          fileDownload: true,
        },
        true,
      );

      const href = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = href;
      const filename = headers['content-disposition']?.match(/filename="([^"]*)"/)[1] || `${fileName}`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return { data, headers };
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['importer', variables.importerId] });
    },
    onError: (error) => {
      showErrorToast(error, `Error downloading document!`);
    },
  });
};
